module.exports = __webpack_public_path__ + "static/media/Y4.4be1dcf5.png";